module.exports = __webpack_public_path__ + "static/media/content.a90b768a.svg";